import Vue from 'vue'

export const store = Vue.observable({
  ref: null
})
export const mutations = {
  setRef: (ref) => {
    store.ref = ref
  }
}
